import { createContext, useContext, useMemo, type ReactNode } from "react";

export type MenuNavigationContextValue = {
  gradeId: number | null;
  examIds: readonly number[];
  verticalId: number | null;
};

const MenuNavigationContext = createContext<MenuNavigationContextValue | null>(
  null,
);

export function MenuNavigationContextProvider({
  gradeId,
  examIds,
  verticalId,
  children,
}: {
  gradeId: number | null;
  examIds: readonly number[];
  verticalId?: number | null;
  children: ReactNode;
}) {
  const examKey = examIds.join(",");
  const value = useMemo<MenuNavigationContextValue>(
    () => ({
      gradeId,
      examIds: examIds.length ? [...examIds] : [],
      verticalId: verticalId ?? null,
    }),
    [gradeId, examKey, verticalId],
  );

  return (
    <MenuNavigationContext.Provider value={value}>
      {children}
    </MenuNavigationContext.Provider>
  );
}

export function useMenuNavigationProgram(): MenuNavigationContextValue {
  return (
    useContext(MenuNavigationContext) ?? {
      gradeId: null,
      examIds: [],
      verticalId: null,
    }
  );
}
